<template>
    <button>
        <slot></slot>
        <svg v-if="arrow" width="18" height="14" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path
            d="M13.293 5.293a1 1 0 0 1 1.414 0l6 6A1.006 1.006 0 0 1 21 12l-.004-.085c.002.017.003.034.003.052L21 12a1.018 1.018 0 0 1-.146.52 1.035 1.035 0 0 1-.147.187l.08-.09a1.003 1.003 0 0 1-.007.008l-.073.082-6 6a1 1 0 0 1-1.414-1.414l4.292-4.294L4 13a1 1 0 0 1-.993-.883L3 12a1 1 0 0 1 1-1l13.585-.001-4.292-4.292a1 1 0 0 1-.083-1.32Z" id="a"/></defs><use fill-rule="nonzero" xlink:href="#a" transform="translate(-3 -5)"/></svg>
        <svg v-else-if="dropdown" width="14" height="8" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path
            d="M12 13.586 6.707 8.293a1 1 0 0 0-1.414 1.414l6 6a1 1 0 0 0 1.414 0l6-6a1 1 0 1 0-1.414-1.414L12 13.586Z" id="a"/></defs><use fill-rule="nonzero" xlink:href="#a" transform="translate(-5 -8)"/></svg>

    </button>
</template>

<script>
export default {
    name: "SiteButton",
    props:{
        arrow: Boolean,
        dropdown: Boolean
    }
}
</script>

<style scoped>

</style>